module.exports = __webpack_public_path__ + "static/media/group-65.9dbb5bc6.svg";